import css from "styled-jsx/css";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH, TABLET_QUERY_MAX_WIDTH } from "constants/vp-sizes";
import colors from "styles/colors";
import {
  BACKGROUND_GRAY_COLOR_NAME,
  DARK_WORK_OS_IRIS_COLOR_NAME,
  WHITE_COLOR_NAME,
  WORK_OS_IRIS_COLOR_NAME
} from "styles/color-consts";
import { TOP_LAYER } from "constants/z-index";
import { getComponentShadowFilter } from "segments/desktop/constants";

export const componentStyles = css.global`
  .use-cases-tabs-component {
    max-width: ${`${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px`};
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .use-cases-tabs-navigation {
      display: flex;
      gap: 8px;
      justify-content: center;
      max-width: ${TABLET_QUERY_MAX_WIDTH};
      flex-wrap: wrap;
      .use-cases-tab-nav-button-wrapper {
        font-weight: 500;
        padding: 7px 16px 9px;
        border-radius: 20px;
        border: ${`1px solid ${colors[DARK_WORK_OS_IRIS_COLOR_NAME]}`};
        white-space: nowrap;
        transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out, border-color 0.2s ease-in-out;
        &:hover {
          background-color: ${colors[BACKGROUND_GRAY_COLOR_NAME]};
          color: ${colors[DARK_WORK_OS_IRIS_COLOR_NAME]};
          cursor: pointer;
        }
        &.selected {
          background-color: ${colors[DARK_WORK_OS_IRIS_COLOR_NAME]};
          color: ${colors[WHITE_COLOR_NAME]};
        }
      }
    }
    .carousel-wrapper {
      max-width: calc(1440px - 40px);
      align-self: center;
      .carousel-item {
        text-align: center;
        .use-case-tab-content {
          padding: 0 48px;
          .use-case-product-banner {
            display: flex;
            justify-content: space-between;
            align-items: center;
            filter: ${getComponentShadowFilter(0.16)};
            gap: 32px;
            padding: 16px 24px;
            .use-case-product-banner-logo-and-text-wrapper {
              display: flex;
              gap: 32px;
              .use-case-product-banner-badge-and-logo {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 8px;
                .core-badge-component {
                  height: fit-content;
                  margin-top: 10px;
                }
                svg {
                  height: 24px;
                  width: 100%;
                }
              }
              .use-case-product-banner-text {
                text-align: left;
              }
            }
          }
        }
      }
      .carousel-arrow-wrapper {
        cursor: pointer;
        z-index: ${TOP_LAYER};
        text-align: center;
        width: 64px;
        height: 64px;
        outline: revert;
        top: calc(50% - 164px);
        &:before {
          display: none;
        }
        &:hover {
          svg {
            path {
              fill: ${colors[WORK_OS_IRIS_COLOR_NAME]};
            }
          }
        }
        &.prev {
          left: -64px;
        }
        &.next {
          right: -64px;
        }
        svg {
          height: 100%;
          path {
            fill: ${colors.mud};
            transition: fill 0.2s ease-in-out;
          }
        }
      }
    }
  }
`;
